const $ = require('jquery');
import run from '../../utilities/run';
const targetSelector = "#relese-order-detail";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import EditChecker from '../../components/EditChecker/EditChecker';
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";

run(targetSelector,(mainEl) => {
  const orderReleaseUrl = mainEl.data("order-release-url");
  const detailPageUrl = mainEl.data("page-refresh-url");
  const releaseBtn = mainEl.find(".release-order-btn");

  const releaseModal = new SubmitModalFlow({
    confirmModalTitle: 'Release Order(s)',
    confirmModalBody: `<div class="q-marg-all-xl">
                          <div class="q-marg-vert-md">
                            Confirming the manual release of this Order(s) will trigger it's original release process.
                          </div>
                          <div class="q-marg-vert-md">
                            Once released, order status will be updated.
                          </div>
                        </div>`,
    confirmModalBtnText: 'Release',
    modalDialogClass: "q-modal-dialog-500",
    onConfirmClick: function(){
      releaseModal.showLoadingModal();
      releaseOrder({url: orderReleaseUrl, success:releaseSuccess, error:releaseError});
    }
  });
  
  releaseModal.init();

  $(releaseBtn).on("click", function(e){
    e.preventDefault();
    releaseModal.showConfirmModal();
  });

  function releaseOrder({url, success, error}){
    $.ajax({
      url: url,
      dataType:"JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }

  function releaseSuccess(data){
    if(data.response === "success"){
      EditChecker.setPageClean();
      releaseModal.showSuccessModal();
      setTimeout(function() {
        location.href = detailPageUrl;
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }else{
      releaseModal.showFailureModal();
    }
  }

  function releaseError(){
    releaseModal.showFailureModal();
  }

});


// WEBPACK FOOTER //
// ./src/pages/releaseOrders/details.js